import { useEffect, useMemo, useState } from "react";
import { createItem, moveArrayItem } from "./helpers";

/**
 * 
 * @param {*} initialItems 
 * @param {object} callbacks 
 * @param {{(text:string)=>{success:boolean, id:number}}} callbacks.onAdd
 * @param {function} callbacks.onRemove
 *  @param {function} callbacks.onToggle
 *  @param {function} callbacks.onChange
 * @returns 
 */
export function useChecklist(initialItems, callbacks = {}) {
  const {
    onAdd,
    onUpdate,
    onRemove,
    onToggle,
    onChange,
    onSetComment,
  } = callbacks;

  const [items, setItems] = useState(
    []
  );

  const [insertedItems, setInsertedItems] = useState([]);
  const [updatedItems, setUpdatedItems] = useState([]);
  const [removedItems, setRemovedItems] = useState([]);
  const itemsKey = useMemo(
    () => initialItems.map(item => `${item.id}-${item.done}-${item.doneByName}`).join(","),
    [initialItems]
  );
  useEffect(() => {
    setItems(initialItems.map(createItem));

  }, [itemsKey])

  useEffect(() => {
    onChange?.({
      items,
      insertedItems,
      updatedItems,
      removedItems,
    });
  }, [items, insertedItems, updatedItems, removedItems]);

  // ADD
  const addItem = async (text) => {
    const item = createItem(text);
    // const result =
    //   typeof onAdd === "function"
    //     ? await onAdd(item)
    //     : true;
    // if (result !== false) {
    //   setItems(prev => [...prev, item]);
    //   setInsertedItems(prev => [...prev, item]);
    // }
    try {
      const result = typeof onAdd === "function"
        ? await onAdd(item)
        : { success: true };

      const {
        success = true,
        id = null,
      } = (result && typeof result === "object")
          ? result
          : { success: result === undefined || !!result, id: null };

      if (!success) return;

      if (id != null) {
        item.id = id;
      }

      setItems(prev => [...prev, item]);
      setInsertedItems(prev => [...prev, item]);
    } catch (error) {
      console.error(error);
    }
  }

  // UPDATE
  const updateItem = async (id, text) => {
    await onUpdate?.({ id, text });
    setItems(prev =>
      prev.map(i =>
        i.id === id ? { ...i, text } : i
      )
    );

    setUpdatedItems(prev => {
      const exists = prev.find(x => x.id === id);

      if (exists) {
        return prev.map(x =>
          x.id === id ? { ...x, text } : x
        );
      }

      const updated = { id, text };
      return [...prev, updated];
    });


  };

  // REMOVE
  const removeItem = (id) => {
    const target = items.find(i => i.id === id);
    if (!target) return;

    setItems(prev => prev.filter(i => i.id !== id));

    const isInserted = insertedItems.some(x => x.id === id);

    if (isInserted) {
      setInsertedItems(prev =>
        prev.filter(x => x.id !== id)
      );
    } else {
      setRemovedItems(prev => [...prev, target]);
    }

    onRemove?.(target);
  };

  // TOGGLE
  // const toggleItem = (id) => {
  //   let toggled = null;

  //   setItems(prev =>
  //     prev.map(i => {
  //       if (i.id === id) {
  //         toggled = { ...i, done: !i.done };
  //         return toggled;
  //       }
  //       return i;
  //     })
  //   );

  //   if (!toggled) return;

  //   const isInserted = insertedItems.some(x => x.id === id);

  //   if (!isInserted) {
  //     setUpdatedItems(prev => {
  //       const exists = prev.find(x => x.id === id);

  //       if (exists) {
  //         return prev.map(x =>
  //           x.id === id ? { ...x, done: toggled.done } : x
  //         );
  //       }

  //       return [...prev, toggled];
  //     });
  //   }

  //   onToggle?.(toggled);
  // };
  const toggleItem = async (id) => {
    const current = items.find(i => i.id === id);
    if (!current) return;
    current.done = !!current.done;
    const updatedItem = {
      ...current,
      done: !current.done
    };
    const result = { success: true };
    if (typeof onToggle === "function") {
      const toggleResult = await onToggle(updatedItem);
      if (toggleResult) {
        result.success = toggleResult?.Data !== undefined && toggleResult?.Data !== null;
        if (toggleResult.Data?.doneByName) {
          updatedItem.doneByName = toggleResult.Data.doneByName;
          updatedItem.doneDate = toggleResult.Data.doneDate;
        }
      }
    }
    if (!result.success) {
      updatedItem.done = current.done;
    }

    setItems(prev =>
      prev.map(i => i.id?.toString() === id?.toString() ? updatedItem : i)
    );

    setUpdatedItems(prev => {
      const isInserted = insertedItems.some(x => x.id === id);

      if (!isInserted) {
        const exists = prev.find(x => x.id === id);

        if (exists) {
          return prev.map(x =>
            x.id === id ? updatedItem : x
          );
        }

        return [...prev, updatedItem];
      }

      return prev;
    });


  };
  //setComment
  const setComment = async (id, comment) => {
    const current = items.find(i => i.id === id);
    if (!current) return;
    const updatedItem = {
      ...current,
      doneComment: comment
    };
    const result = { success: true };
    if (typeof onSetComment === "function") {
      const commentResult = await onSetComment(updatedItem);
      if (commentResult) {
        result.success = commentResult.Data;
      }
    }
    if (!result.success) {
      updatedItem.done = current.done;
    }
    setItems(prev =>
      prev.map(i => i.id?.toString() === id?.toString() ? updatedItem : i)
    );

    setUpdatedItems(prev => {
      const isInserted = insertedItems.some(x => x.id === id);

      if (!isInserted) {
        const exists = prev.find(x => x.id === id);

        if (exists) {
          return prev.map(x =>
            x.id === id ? updatedItem : x
          );
        }

        return [...prev, updatedItem];
      }

      return prev;
    });


  };
  // MOVE
  const moveItemUp = (index) => {
    setItems(prev => moveArrayItem(prev, index, index - 1));
  };

  const moveItemDown = (index) => {
    setItems(prev => moveArrayItem(prev, index, index + 1));
  };

  return {
    items,
    insertedItems,
    updatedItems,
    removedItems,

    addItem,
    updateItem,
    removeItem,
    toggleItem,
    setComment,
    moveItemUp,
    moveItemDown,
  };
}